import React, { useEffect } from "react";
import { isMobile, isAndroidDevice } from "../../helper/CommonFuncs";
const GetPlayback = () => {
   useEffect(() => {
      if (isMobile()) {
         const url = isAndroidDevice()
            ? "https://play.google.com/store/apps/details?id=com.playbackhealth.pro"
            : "https://apps.apple.com/in/app/playback-health-pro/id6479377243";

         if (url) window.location.href = url;
      } else {
         window.location.href = "/login";
      }
   }, []);

   return <></>;
};

export default GetPlayback;
